export default "__VITE_ASSET__BcnG57AS__"